export const DependerType = {
  EXTRA: "EXTRA",
  GUEST_FORM: "GUEST_FORM",
  CANCELLATION_FORM: "CANCELLATION_FORM",
  ROOMSTAY_CHECKOUT: "ROOMSTAY_CHECKOUT",
};

export const INVENTORY_SELECTOR_TYPES = [
  DependerType.GUEST_FORM,
  DependerType.CANCELLATION_FORM,
  DependerType.ROOMSTAY_CHECKOUT,
];

export const ENGINE_SUPPORTED_LOCALES = ["es", "ca", "en", "fr", "it", "de"];
